import { type Reducer } from "redux";
import type LotteryV2Configuration from "@tootsweet/model/lottery/LotteryV2Configuration";
import {
  SET_CONFIGURATION,
  SET_EVENTS_TYPE,
  SET_POSA_PRICES,
  SET_POSA_TYPES
} from "../actions/wheel";
import { type POSAPricesJavascriptDTO } from "@tootsweet/model/lottery/POSAPrices";
import { type EventConfig } from "kadow-jetpack-model";
import moment from "moment-timezone";
import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";

export type ConfigurationMap = Record<string, LotteryV2Configuration>;

export interface WheelStateI {
  configurations: ConfigurationMap;
  posaPrices: POSAPricesJavascriptDTO[];
  posaTypes: POSATypeJavascriptDTO[];
  events: EventConfig[];
}

const initialState: WheelStateI = {
  configurations: {},
  posaPrices: [],
  posaTypes: [],
  events: []
};

const wheelReducer: Reducer<WheelStateI> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SET_CONFIGURATION:
      return {
        ...state,
        configurations: {
          ...state.configurations,
          [action.account]: action.configuration
        }
      };
    case SET_POSA_TYPES:
      return {
        ...state,
        posaTypes: action.posaTypes
      };
    case SET_POSA_PRICES:
      return {
        ...state,
        posaPrices: action.posaPrices
      };

    case SET_EVENTS_TYPE:
      const now = moment();

      /**
       * Remove expired events
       */
      if (action.events) {
        for (let idx = action.events.length - 1; idx >= 0; idx--) {
          const ev = action.events[idx] as EventConfig;

          /**
           * Remove one-shot, expired events
           */
          if (
            ev.endYear !== undefined &&
            ev.endYear !== null &&
            ev.endYear > 0 &&
            ev.maxMonth !== undefined &&
            ev.maxMonth !== null &&
            ev.maxMonth > 0 &&
            ev.maxDay !== undefined &&
            ev.maxDay !== null &&
            ev.maxDay > 0
          ) {
            const endM = moment()
              .year(ev.endYear)
              .month(ev.maxMonth)
              .date(ev.maxDay);

            if (endM.isBefore(now)) {
              action.events.splice(idx, 1);
            }
          }
        }
      }

      return {
        ...state,
        events: action.events
      };
  }
  return state;
};

export default wheelReducer;
